import React,{useEffect} from 'react'
import {TextField} from '@mui/material';
import Button from '@mui/material/Button';
import { useForm } from "react-hook-form";



const EditRegisterdetails = ({ onSubmit,onClick }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onTouched" });

  useEffect(() => {
    setValue('firstname', sessionStorage.getItem('firstname') || '');
    setValue('lastname', sessionStorage.getItem('lastname') || '');
    setValue('email', sessionStorage.getItem('email') || '');
    setValue('phone', sessionStorage.getItem('phonenumber') || '');
  }, [setValue]);

  // useEffect(()=>{
  //   setValue("firstname",FirstName);
  //   setValue("lastname",lastName);
  //   setValue("email",Email);
  //   setValue("phone",phoneNumber);
  // },[])
  // const onSubmitForm = (data) => {
  //   onSubmit(data);
  // };

  const handleInputChange = (name, value) => {
    sessionStorage.setItem(name, value);
  };

  const onSubmitForm = (data) => {
    // You can retrieve form data using getValues() and update session storage
    Object.keys(data).forEach((key) => {
      handleInputChange(key, data[key]);
    });

    // Call the onSubmit callback
    onSubmit(data);
  };
 
  return (
    <div>
         <h2>Registration Details</h2>
         <form onSubmit={handleSubmit(onSubmitForm)}>
        <div style={{ marginTop: "12px" }}>
            {/* <label>First name:</label> */}
            <TextField
              sx={styles.textfield}
              id="outlined-basic"
              label="First name"
              variant="outlined"
              {...register("firstname", {
                required: "First Name is required",
                errorMessage: "name is allowed in only letters",
                pattern: {
                  value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                  message: "Only alphabets are allowed",
                },
              })}
              onChange={(e) => handleInputChange('firstname', e.target.value)}
            />
            {errors.firstname && (
              <div
                style={{
                  color: "red",
                  fontSize: "14px",
                  textAlign: "left",
                  marginLeft: "45px",
                }}
              >
                {errors.firstname.message}
              </div>
            )}
          </div>
          <div style={{ marginTop: "12px" }}>
            {/* <label>Last name:</label> */}
            <TextField
              sx={styles.textfield}
              id="outlined-basic"
              label="Last name"
              variant="outlined"
              {...register("lastname", {
                required: "Last Name is required",
                errorMessage: "Last name is allowed in only letters",
                pattern: {
                  value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                  message: "Only alphabets are allowed",
                },
              })}
              onChange={(e) => handleInputChange('lastname', e.target.value)}
            />
            {errors.lastname && (
              <div
                style={{
                  color: "red",
                  fontSize: "14px",
                  textAlign: "left",
                  marginLeft: "45px",
                }}
              >
                {errors.lastname.message}
              </div>
            )}
          </div>
          <div style={{ marginTop: "12px" }}>
            {/* <label>Email address:</label> */}
            <TextField
              sx={styles.textfield}
              id="outlined-basic"
              label="Email address"
              variant="outlined"
              {...register("email", {
                required: "Email address is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Invalid Email Address",
                },
              })}
              onChange={(e) => handleInputChange('email', e.target.value)}
            />
            {errors.email && (
              <div
                style={{
                  color: "red",
                  fontSize: "14px",
                  textAlign: "left",
                  marginLeft: "45px",
                }}
              >
                {errors.email.message}
              </div>
            )}
          </div>
          <div style={{ margin: "12px 0px 14px 0px" }}>
            {/* <label>Phone number:</label> */}
            <TextField
              sx={styles.textfield}
              id="outlined-basic"
              label="Phone number"
              variant="outlined"
              {...register("phone", {
                required: "Phone number is required",
                pattern: {
                  value: /^\d{10}$/,
                  message: "Invalid Phone Number (10 digits)",
                },
              })}
              onChange={(e) => handleInputChange('phonenumber', e.target.value)}
            />
            {errors.phone && (
              <div
                style={{
                  color: "red",
                  fontSize: "14px",
                  textAlign: "left",
                  marginLeft: "45px",
                }}
              >
                {errors.phone.message}
              </div>
            )}
          </div>
        <Button type="submit"  sx={{
          ...styles.btnprofessional,
          // Add conditional styles based on the disabled state
          '&:disabled': {
            color: 'rgba(0, 0, 0, 0.5)', // Dull color when disabled
            backgroundColor: 'rgba(0, 0, 0, 0.1)', // Background color when disabled
          },
        }}>
          Save
        </Button>
        <Button sx={styles.btnprofessional} type="button" onClick={onClick}>
      Next
    </Button>
         </form>
    </div>
  )
}

export default EditRegisterdetails

const styles = {
   
    textfield: {
      width: "400px",
    },
    btn: {
      width: "400px",
      height: "40px",
      marginTop: "1em",
      backgroundColor: "#002C51",
      color: "white",
      textTransform: "none",
      "&:hover": {
        background: "#002C51",
      },
    },
    dashboard_paper: {
      height: "40px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "15px",
    },
    btnprofessional: {
      margin:"10px",
      width: "100px",
      height: "40px",
      marginTop: "1em",
      backgroundColor: "#002C51",
      color: "white",
      textTransform: "none",
      "&:hover": {
        background: "#002C51",
      },
    },
  };
  